import { render, staticRenderFns } from "./project_edit_m.vue?vue&type=template&id=753db26e&scoped=true&"
import script from "./project_edit_m.vue?vue&type=script&lang=js&"
export * from "./project_edit_m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753db26e",
  null
  
)

export default component.exports